import { useMutation } from "@tanstack/react-query"

import { rebook } from "../../services/BookingService"
import { RebookRequestType } from "../../types/BookingInfoTypes"
import { GetOrderDetailsResponseType } from "../../types/OrderTypes"
import { GenericMutateOptionsType } from "../cart/hooks"

export const useRebookMutation = ({
  mutateOptions,
}: GenericMutateOptionsType<
  {
    bookingId: string
    body: RebookRequestType
    filter: Record<string, string | boolean>
  },
  GetOrderDetailsResponseType
> = {}) =>
  useMutation({
    mutationFn: async ({ bookingId, body, filter }) => {
      const { data } = await rebook(bookingId, body, filter)
      return data
    },
    ...mutateOptions,
  })
